import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import styled, { css } from 'styled-components'

import { Box } from '@wirtualna-polska/n2cr-ds'
import { getBanners } from '@ads/front-core/store/selectors/getBanners'
import zIndex from '@ads/front-core/constants/zIndex'
import BannerItem from './BannerItem'

const Banners: FC = () => {
  const banners = useSelector(getBanners)
  const bannersIds = Object.keys(banners)

  return (
    <>
      <OnLayerBanners data-testid="banners">
        {bannersIds.map(
          (id: string) =>
            !banners[id].showOnTop && (
              <BannerItem key={`banner-${id}`} id={id} banner={banners[id]} />
            ),
        )}
      </OnLayerBanners>
      <AboveHeaderBanners>
        {bannersIds.map(
          (id: string) =>
            banners[id].showOnTop && (
              <BannerItem key={`banner-${id}`} id={id} banner={banners[id]} />
            ),
        )}
      </AboveHeaderBanners>
    </>
  )
}

const OnLayerBanners = styled(Box)`
  ${p => css`
    display: grid;
    gap: ${p.theme.space.xs}px;
    position: fixed;
    top: ${p.theme.space.xl}px;
    left: ${p.theme.space.xl}px;
    right: ${p.theme.space.xl}px;
    z-index: ${zIndex.BANNER};
  `}
`

const AboveHeaderBanners = styled(Box)`
  ${p => css`
    background: ${p.theme.colors.inverted100};
    display: grid;
    gap: ${p.theme.space.xxxs}px;
  `}
`

export default Banners
